import React from 'react';
import { Typography, Box } from '@mui/material';

const Users = () => {
  return (
    <Box textAlign="center">
      <Typography variant="h5" gutterBottom fontWeight={700}>
        Users
      </Typography>
      <Typography variant="body2" color="text.secondary">
        User management coming soon...
      </Typography>
    </Box>
  );
};

export default Users;
